import React, { useMemo, useState } from 'react';
import Masonry from './Masonry';

export default function VfxPortfolio({ onBack }) {
  
  // 1. 记录当前被点击放大的视频
  const [activeVideo, setActiveVideo] = useState(null);

  // 2. 视频数据源 (直接在这里填你的视频名字，type 分为 horizontal 横屏 / vertical 竖屏)
  const rawProjects = [
    { id: 1, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos/vfx-1.mp4", type: "horizontal" }, 
    { id: 2, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos/proya.mp4", type: "vertical" },   
    { id: 3, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos/%E5%BC%80%E8%8A%B1.mp4", type: "horizontal" },
    { id: 4, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos/%E7%B2%BE%E5%8D%8E%E6%B6%B2_%E9%99%8D%E5%99%AA.mp4", type: "vertical" },
    { id: 5, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos/%E9%9D%A2%E5%8C%85%E6%A0%91.mp4", type: "horizontal" },
    { id: 6, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos/%E6%A4%85%E5%AD%90.mp4", type: "vertical" },
    { id: 7, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos/%E8%A1%A8.mp4", type: "horizontal" },
    { id: 8, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos/%E8%A1%A8%E5%B8%A6%E7%BC%96%E5%88%B6.mp4", type: "vertical" },
    { id: 9, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos/%E5%BF%83%E5%8A%A8%E5%A5%87%E9%81%87%E8%A7%84%E5%88%99.mp4", type: "horizontal" },
    { id: 10, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos/%E7%BF%85%E8%86%80%E5%A4%B4%E5%83%8F%E6%A1%86.mp4", type: "horizontal" },
    { id: 11, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos/%E6%AF%9B%E5%8F%91%E6%A8%A1%E6%8B%9F.mp4", type: "vertical" },
    { id: 12, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos/%E7%A4%BC%E7%89%A9.mp4", type: "horizontal" },
    { id: 13, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos/Adidas%20Ozweego.mp4", type: "vertical"},
    { id: 14, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos/%E5%9C%B0%E7%90%83.mp4", type: "horizontal" },
    { id: 15, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos/%E7%BC%96%E5%88%B6-1.mp4", type: "horizontal" },
    { id: 16, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos/%E9%BC%A0%E6%A0%87.mp4", type: "horizontal" },
    { id: 17, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos/DNA.mp4", type: "horizontal" },
    { id: 18, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos/%E8%80%B3%E6%9C%BA.mp4", type: "vertical"},
    { id: 19, videoUrl: "https://wangtao-portfolio.oss-cn-chengdu.aliyuncs.com/videos/%E5%8F%A4%E9%A3%8E.mp4", type: "vertical"},
  ];

  // 3. 智能比例换算引擎
  const vfxProjects = useMemo(() => {
    return rawProjects.map(item => {
      const calculatedHeight = item.type === 'vertical' ? 600 : 350;
      return {
        ...item,
        height: calculatedHeight
      };
    });
  }, []); 

  return (
    <div className="min-h-screen bg-[#050505] text-white pt-10 px-6 md:px-12 pb-24 overflow-x-hidden relative animate-[fadeIn_0.8s_ease-out]">
      
      {/* ================= 左上角：返回按钮 ================= */}
      <button 
        onClick={onBack}
        className="fixed top-8 left-8 z-50 flex items-center gap-2 text-neutral-400 hover:text-white transition-colors duration-300 group backdrop-blur-md bg-black/20 px-4 py-2 rounded-full border border-white/10"
      >
        <svg className="w-5 h-5 transition-transform duration-300 group-hover:-translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path></svg>
        <span className="font-mono text-sm tracking-widest">BACK</span>
      </button>

      {/* ================= 页面抬头 ================= */}
      <div className="max-w-[1600px] mx-auto mt-20 mb-16 space-y-4 text-center md:text-left pl-0 md:pl-8 border-l-0 md:border-l-4 border-emerald-500">
        <h1 className="text-5xl md:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-600 tracking-tighter">
          特效制作
        </h1>
        <p className="text-neutral-500 font-mono tracking-widest uppercase text-sm">
          C4D// oc // XP // HUODINI  // AE
        </p>
      </div>

      {/* ================= 瀑布流组件 ================= */}
      <div className="max-w-[1600px] mx-auto">
        <Masonry 
          items={vfxProjects} 
          ease="power3.out"
          duration={0.8}
          // 接收点击事件，激活视频播放器
          onItemClick={(item) => setActiveVideo(item)} 
        />
      </div>

      {/* ================= 🎬 终极视觉魔法：全屏毛玻璃视频播放器 ================= */}
      {activeVideo && (
        <div 
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 backdrop-blur-2xl transition-all"
          onClick={() => setActiveVideo(null)} // 点击背景任意处关闭
        >
          {/* 右上角关闭按钮 */}
          <button 
            className="absolute top-8 right-8 p-4 text-white/50 hover:text-white transition-colors duration-300 hover:rotate-90"
            onClick={() => setActiveVideo(null)}
          >
            <svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6 18L18 6M6 6l12 12" /></svg>
          </button>

          {/* 视频容器 */}
          <div 
            className="relative w-[90%] md:w-[80%] max-w-7xl max-h-[85vh] bg-black rounded-xl md:rounded-3xl overflow-hidden shadow-[0_0_80px_rgba(0,255,150,0.1)] border border-white/10"
            onClick={(e) => e.stopPropagation()} // 防止点击视频本身时关闭
          >
            <video 
              src={activeVideo.videoUrl}
              className="w-full h-full max-h-[85vh] object-contain"
              autoPlay  
              loop
              playsInline
              muted     // 强制静音，保证自动播放成功
              controls  // 🚀 新增这一行：召唤出进度条、播放/暂停按钮！
            />
          </div>
        </div>
      )}

    </div>
  );
}